import { createContext, useContext, useState, useCallback } from "react";

const PlanModalContext = createContext();

export function PlanModalProvider({ children }) {
    const [isPlanModalOpen, setIsPlanModalOpen] = useState(false);

    const openPlanModal = useCallback(() => setIsPlanModalOpen(true), []);
    const closePlanModal = useCallback(() => setIsPlanModalOpen(false), []);

    return (
        <PlanModalContext.Provider value={{ isPlanModalOpen, openPlanModal, closePlanModal }}>
            {children}
        </PlanModalContext.Provider>
    );
}

export function usePlanModal() {
    return useContext(PlanModalContext);
}